const GA_MEASUREMENT_ID = 'G-SEQ9F4ZNQF';

/** Load Google Analytics only in production builds. */
export function initAnalytics(): void {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}
